export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          Terms of Service
        </h1>
        
        <div className="prose dark:prose-invert">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using QudusOnline, you agree to be bound by these Terms of Service
            and all applicable laws and regulations.
          </p>

          <h2>Use License</h2>
          <p>
            Permission is granted to temporarily access QudusOnline for personal,
            non-commercial transitory viewing only.
          </p>

          <h2>User Responsibilities</h2>
          <ul>
            <li>Maintain the security of your account credentials</li>
            <li>Provide accurate and complete information</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Not interfere with the proper working of the service</li>
          </ul>

          <h2>Service Modifications</h2>
          <p>
            We reserve the right to modify or discontinue, temporarily or permanently,
            QudusOnline with or without notice.
          </p>

          <h2>Governing Law</h2>
          <p>
            These terms shall be governed by and construed in accordance with the laws of
            the jurisdiction in which QudusOnline operates.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about the Terms of Service should be sent to us at:
            support@qudusapp.com
          </p>
        </div>
      </div>
    </div>
  );
}